<template>
  <div id="fileUpload">
    <div
      v-if="flu_show !== -1"
      :class="{ 'flu-mask': true, 'flu-mask-close': flu_show === 2 }"
      @click="vflu_close"
    ></div>
    <div
      v-if="flu_show !== -1"
      :class="{ 'flu-model': true, 'flu-model-show': flu_show === 1 }"
    >
      <div class="flu-model-first">
        <!-- 左边框框 -->
        <div class="flu-model-fir-left no-copy">
          <!-- 未上传 -->
          <div v-if="flu_status === 0" class="flu-model-fir-left-static">
            <img
              class="flu-model-fir-left-static-img"
              src="@/assets/icon/file.png"
            />
            <div class="font-14 color-prompt">拖到此处、或点击选择文件上传</div>
          </div>
          <!-- 上传中 -->
          <div v-else-if="flu_status === 1" class="flu-model-fir-left-dynamic">
            <div class="flu-model-fir-left-dynamic-line">
              <div class="flu-model-fir-left-dynamic-line-point"></div>
            </div>
            <div class="flu-model-fir-left-dynamic-plate"></div>
            <div class="flu-model-fir-left-dynamic-font font-14 color-prompt">
              上传中....
            </div>
          </div>
          <!-- 上传成功 -->
          <div v-else-if="flu_status === 2" class="flu-model-fir-left-static">
            <img
              class="flu-model-fir-left-static-img"
              src="@/assets/icon/success.png"
            />
            <div class="font-14 color">上传成功....</div>
          </div>
          <!-- 上传失败 -->
          <div v-else-if="flu_status === 3" class="flu-model-fir-left-static">
            <img
              class="flu-model-fir-left-static-img"
              src="@/assets/icon/fail.png"
            />
            <div
              class="flu-model-fir-left-static-failfont font-14 color-prompt"
            >
              上传失败....
            </div>
          </div>

          <input
            v-if="input_disabled"
            class="flu-model-fir-left-input"
            title
            type="file"
            ref="vflufileInput"
            @change="vflu_fileInputChange"
          />
        </div>

        <!-- 右侧-按钮及提示 -->
        <div class="flu-model-fir-right">
          <!-- 首行按钮及提示 -->
          <div class="flu-model-fir-rig-btn no-copy">
            <div class="flu-model-fir-rig-btn-font font-16 color">
              {{ prompt ? prompt : "" }}
            </div>
            <img
              class="flu-model-fir-rig-btn-cancel"
              title="取消"
              src="@/assets/icon/cancel.png"
              @click="vflu_close"
            />
          </div>
          <!-- 提示 -->
          <div class="flu-model-fir-rig-prompt font-14 color-prompt">
            上传文件时，请不要关闭浏览器！
          </div>
          <div class="flu-model-fir-rig-prompt font-14 color-prompt">
            <div>文件上传格式：</div>
            <div>jpg，png，gif，jpeg，cdr，ai，zip，rar，tiff，eps，pdf</div>
          </div>
        </div>
      </div>

      <!-- 上传の文件 -->
      <div class="flu-model-third font-14 color-prompt-deep">
        <span v-if="fileInfo">上传文件：{{ fileInfo.name }}</span>
      </div>

      <div class="flu-model-second">
        <!-- 进度条 -->
        <div class="flu-model-sec-progress">
          <div
            class="flu-model-sec-progress-solid"
            :style="{ width: proging + '%' }"
          ></div>
        </div>
        <!-- 规格 -->
        <div class="flu-model-sec-data">
          <!-- 进度 -->
          <div class="flu-model-sec-data-progs font-14 color">
            {{ proging }}%
          </div>
          <!-- 大小 -->
          <div class="flu-model-sec-data-size font-14 color-prompt-deep">
            {{ fileInfo.fileSize ? fileInfo.fileSize : 0 }}kb
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "fileUpload",
  props: {},
  data() {
    return {
      flu_show: -1,
      /* 
			flu_status: 
				0: 未上传,
				1: 上传中(已选择文件)
				2: 上传成功
				3: 上传失败
			*/
      flu_status: 0, //上传文件状态
      input_disabled: true, //是否启用'选择文件'
      fileInfo: false, //上传的文件信息
      proging: 0, //进度
      prompt: false, //当前上传文件提示
      static: false, //是否由父级控制流程及显示
      currentPaper: "", //下单所选材料
      GramWeight: "", //用纸重量
      shuliang: "", //下单时所填个数
      producttype: "",
      chichunstr: "",
      chichunstrxx: "", //尺寸
      chichunstryy: "",
      fangshi: "", //中西式
      offer_string: "",
      yanse: "", //颜色
    };
  },
  watch: {},
  methods: {
    // show方法
    vflu_Change(file, prompt) {
      if (file && file.constructor["name"] === "File") {
        this.static = true;
        this.flu_status = 1;
        this.fileInfo = file;
        this.input_disabled = false;
        if (prompt && prompt.constructor["name"] === "String") {
          this.prompt = prompt;
        } else {
          this.prompt = false;
        }
      } else {
        this.static = false;
        this.flu_status = 0;
        this.fileInfo = false;
        this.input_disabled = true;
      }
      this.proging = 0;
      this.flu_show = 0;
      setTimeout(() => {
        this.flu_show = 1;
      }, 20);
    },
    vflu_Change1(
      currentPaper,
      GramWeight,
      shuliang,
      producttype,
      chichunstr,
      chichunstrxx,
      chichunstryy,
      fangshi,
      offer_string,
      danshuang
    ) {
      console.log(
        "材料：",
        currentPaper,
        "克重：",
        GramWeight,
        "数量：",
        shuliang,
        "产品编号：",
        producttype,
        "尺寸名称：",
        chichunstr,
        "方式：",
        fangshi,
        "文本：",
        offer_string
      );
      this.danshuang = danshuang;
      this.offer_string = offer_string;
      this.static = false;
      this.flu_status = 0;
      this.fileInfo = false;
      this.input_disabled = true;
      this.proging = 0;
      this.flu_show = 0;
      this.currentPaper = currentPaper;
      this.GramWeight = GramWeight;
      this.shuliang = shuliang;
      this.producttype = producttype;
      this.chichunstr = chichunstr;
      this.chichunstrxx = chichunstrxx;
      this.chichunstryy = chichunstryy;
      this.fangshi = fangshi;
      setTimeout(() => {
        this.flu_show = 1;
      }, 20);
    },
    // close方法
    vflu_close() {
      this.prompt = false;
      // 文件上传中-不允许关闭
      // if (this.flu_status !== 1) {
      this.flu_show = 2;
      setTimeout(() => {
        this.flu_show = -1;
      }, 310);
      // }
    },
    vflu_fileInputChange(event) {
      let file = this.$refs.vflufileInput.files[0];
      file.fileSize = (file["size"] / 1024).toFixed(2);

      const file_type = [
        "jpg",
        "png",
        "gif",
        "jpeg",
        "cdr",
        "ai",
        "zip",
        "rar",
        "tiff",
        "eps",
        "pdf",
      ];
      let fileIsTrue = false;
      for (let i in file_type) {
        if (
          file.name.endsWith(file_type[i]) ||
          file.name.endsWith(file_type[i].toLocaleUpperCase())
        ) {
          fileIsTrue = true;
          break;
        }
      }
      if (this.producttype !== "pidnon_fb") {
        //所有产品数量校验
        let wjmshuliang = "";
        if (file.name.indexOf("百") >= 0) {
          const numberzs = file.name.substr(file.name.indexOf("百") - 1, 1);
          wjmshuliang = Number(numberzs) * 100;
        } else if (file.name.indexOf("千") >= 0) {
          const numberzs = file.name.substr(file.name.indexOf("千") - 1, 1);
          wjmshuliang = Number(numberzs) * 1000;
        } else if (file.name.indexOf("万") >= 0) {
          const numberzs = file.name.substr(file.name.indexOf("万") - 1, 1);
          wjmshuliang = Number(numberzs) * 10000;
        } else if (file.name.indexOf("个") >= 0) {
          let zhangshu = file.name.match("\\d+(个|箱|张|本)");
          let zhangshuarr = zhangshu[0].split(zhangshu[1]);
          wjmshuliang = zhangshuarr[0];
        }
        if (wjmshuliang > 0 && Number(this.shuliang) !== Number(wjmshuliang)) {
          this.prompt =
            "下单数量" +
            this.shuliang +
            "和文件名数量" +
            wjmshuliang +
            "不一致，请确认";
          fileIsTrue = false;
        }
        //所有材料校验
        let cailiaos = "双胶,白牛皮,黄牛皮,双铜,单铜,哑粉,冰白,灰底白,白底白";
        let qiege2 = [];
        qiege2 = cailiaos.split(",");
        for (let i in qiege2) {
          if (file.name.indexOf(qiege2[i]) >= 0) {
            if (this.currentPaper && this.currentPaper.indexOf(qiege2[i]) < 0) {
              this.prompt =
                "材料(" + this.currentPaper + ")和文件不一致,请重新选择";
              fileIsTrue = false;
              break;
            }
          }
        }
        if (
          file.name.indexOf("牛皮") >= 0 &&
          file.name.indexOf("白牛皮") < 0 &&
          file.name.indexOf("黄牛皮") < 0
        ) {
          this.prompt = "请完善文件名中材料是否为白牛皮或者黄牛皮";
          fileIsTrue = false;
        }
        if(file.name.indexOf(')')>=0 ||file.name.indexOf('(')>=0){
          this.prompt = '请删除文件中的括号'
          fileIsTrue = false;
        }
        //所有产品克重校验
        let kezhong = file.name.match("\\d+(克|G|g)");
        if (kezhong) {
          let shijike = this.GramWeight + "克";
          let wenjianke = "";
          if (kezhong.indexOf("g") >= 0) {
            wenjianke = kezhong[0].replace("g", "克");
          } else if (kezhong.indexOf("G") >= 0) {
            wenjianke = kezhong[0].replace("G", "克");
          } else if (kezhong.indexOf("克") >= 0) {
            wenjianke = kezhong[0];
          } else {
            this.prompt = "克重异常";
            fileIsTrue = false;
          }
          if (wenjianke !== shijike) {
            this.prompt = "克重(" + shijike + ")和文件不一致,请重新选择";
            fileIsTrue = false;
          }
        }
        //部分产品单双面校验
        if (
          (file.name.indexOf("单面") >= 0 &&
            this.danshuang &&
            this.danshuang == 2) ||
          (file.name.indexOf("双面") >= 0 &&
            this.danshuang &&
            this.danshuang == 1)
        ) {
          this.prompt = "请确认选中单双面是否与文件要求一致";
            fileIsTrue = false
        }
        if (this.currentPaper !== "" && this.producttype == "pidenv_xf") {
          //信封处理方式
          let wenjianfs = "";
          if (this.offer_string.indexOf("中式") >= 0) {
            let cuowu = [
              "西尖",
              "西平",
              "尖舌",
              "平舌",
              "尖盖",
              "平盖",
              "西式",
              "边封",
              "开窗",
            ];

            for (let i in cuowu) {
              if (file.name.indexOf(cuowu[i]) >= 0) {
                wenjianfs = cuowu[i];
              }
            }
            if (wenjianfs) {
              this.prompt =
                "文件方式(" + wenjianfs + ")和所选不一致,请重新选择";
              fileIsTrue = false;
            }
          } else if (this.offer_string.indexOf("西式尖舌") >= 0) {
            let cuowu = ["中式", "西平", "平舌", "平盖", "边封", "开窗"];
            for (let i in cuowu) {
              if (file.name.indexOf(cuowu[i]) >= 0) {
                wenjianfs = cuowu[i];
              }
            }
            if (wenjianfs) {
              this.prompt =
                "文件方式(" + wenjianfs + ")和所选不一致,请重新选择";
              fileIsTrue = false;
            }
          } else if (this.offer_string.indexOf("西式平舌") >= 0) {
            let cuowu = ["中式", "西尖", "尖舌", "尖盖", "边封", "开窗"];
            for (let i in cuowu) {
              if (file.name.indexOf(cuowu[i]) >= 0) {
                wenjianfs = cuowu[i];
              }
            }
            if (wenjianfs) {
              this.prompt =
                "文件方式(" + wenjianfs + ")和所选不一致,请重新选择";
              fileIsTrue = false;
            }
          } else if (this.offer_string.indexOf("西式开窗") >= 0) {
            let cuowu = [
              "中式",
              "西平",
              "平舌",
              "平盖",
              "西尖",
              "尖舌",
              "尖盖",
              "边封",
            ];
            for (let i in cuowu) {
              if (file.name.indexOf(cuowu[i]) >= 0) {
                wenjianfs = cuowu[i];
              }
            }
            if (wenjianfs) {
              this.prompt =
                "文件方式(" + wenjianfs + ")和所选不一致,请重新选择";
              fileIsTrue = false;
            }
          } else if (this.offer_string.indexOf("边封") >= 0) {
            let cuowu = [
              "中式",
              "西平",
              "平舌",
              "平盖",
              "西尖",
              "尖舌",
              "尖盖",
              "开窗",
            ];
            for (let i in cuowu) {
              if (file.name.indexOf(cuowu[i]) >= 0) {
                wenjianfs = cuowu[i];
              }
            }
            if (wenjianfs) {
              this.prompt =
                "文件方式(" + wenjianfs + ")和所选不一致,请重新选择";
              fileIsTrue = false;
            }
          }
        } else if (
          this.currentPaper !== "" &&
          this.producttype == "pidcards_kuaidifeng"
        ) {
          //快递封套尺寸识别关键字大中小号
          let chichi = file.name.match("(大号|中号|小号)");
          if (chichi) {
            if (this.chichunstr.indexOf(chichi[0]) < 0) {
              this.prompt =
                "文件尺寸(" + chichi[0] + ")和所选不一致,请重新选择";
              fileIsTrue = false;
            }
          }
        } else if (
          this.currentPaper !== "" &&
          this.producttype == "pidleaflet_zbxcd"
        ) {
          //单张尺寸识别判断
          let chichi = "";
          let xxyy = file.name.match("\\d+(X|x)\\d+");
          if (xxyy) {
            if (xxyy[0].indexOf("X") >= 0) {
              chichi = this.chichunstrxx + "X" + this.chichunstryy;
            } else if (xxyy[0].indexOf("x") >= 0) {
              chichi = this.chichunstrxx + "x" + this.chichunstryy;
            }
            if (xxyy[0] !== chichi) {
              this.prompt = "文件尺寸(" + xxyy[0] + ")和所选不一致,请重新选择";
              fileIsTrue = false;
            }
          }
        } else if (
          this.currentPaper !== "" &&
          this.producttype == "pidcards_baikahe"
        ) {
        }
      }

      if (fileIsTrue) {
        this.fileInfo = file;
        this.flu_status = 1;
        this.input_disabled = false;
        this.$parent.func_uploadIng(file);
      } else {
        console.log("文件类型不匹配");
      }
    },
    // 接受上传进度
    vflu_uploadIng(proging) {
      //设置进度条
      this.proging = proging;

      if (proging === "100.00") {
        //上传完成
        this.flu_status = 2;
        if (!this.static) {
          setTimeout(() => {
            this.vflu_close();
          }, 1000);
        }
      } else if (proging === -1) {
        //上传失败
        this.flu_status = 3;
      }
    },
  },
};
</script>
<style scoped>
.flu-mask {
  background: rgba(0, 0, 0, 0);
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 300;
  animation: fluMaskShow 0.3s linear 0s forwards;
}
@keyframes fluMaskShow {
  from {
    background: rgba(0, 0, 0, 0);
  }
  to {
    background: rgba(0, 0, 0, 0.6);
  }
}
.flu-mask-close {
  animation: fluMaskClose 0.3s linear 0s forwards;
}
@keyframes fluMaskClose {
  from {
    background: rgba(0, 0, 0, 0.6);
  }
  to {
    background: rgba(0, 0, 0, 0);
  }
}
.flu-model {
  background: rgba(255, 255, 255, 1);
  width: 520px;
  min-height: 240px;
  box-sizing: border-box;
  padding: 20px 24px;
  border-radius: 6px;
  box-shadow: 0 2px 12px #999;
  position: fixed;
  top: calc((100vh - 240px) / 2);
  left: calc((100% - 520px) / 2);
  z-index: 310;
  opacity: 0;
  transform: scale(1.285);
  transition: all 0.3s ease-in-out 0s;
}
.flu-model-show {
  opacity: 1;
  transform: scale(1);
}

.flu-model-first {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
/* 左边框框 */
.flu-model-fir-left {
  width: 220px;
  height: 160px;
  border-radius: 4px;
  box-shadow: 0 0 6px #aaa;
  overflow: hidden;
  position: relative;
}

.flu-model-fir-left-static {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.flu-model-fir-left-static-img {
  width: 100px;
  height: 100px;
}
.flu-model-fir-left-static-failfont {
  color: #ff0000;
}

.flu-model-fir-left-dynamic {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  position: relative;
}
.flu-model-fir-left-dynamic-line {
  width: 12px;
  height: 60px;
  display: inline-flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  position: absolute;
  top: 30px;
  left: calc((100% - 12px) / 2);
}
.flu-model-fir-left-dynamic-line-point {
  background: #ff6801;
  width: 12px;
  height: 12px;
  border-radius: 100%;
  animation: flumffvlPointAni 0.8s linear 0s infinite;
}
@keyframes flumffvlPointAni {
  0% {
    transform: translateY(0);
  }
  60% {
    transform: translateY(-50px);
  }
  100% {
    transform: translateY(-0);
  }
}
.flu-model-fir-left-dynamic-plate {
  background: linear-gradient(to bottom right, #ddd, #aaa);
  width: 80px;
  height: 24px;
  border-radius: 60%;
}
.flu-model-fir-left-dynamic-font {
  margin: 10px 0 30px 0;
}

.flu-model-fir-left-input {
  background: gray;
  width: 100%;
  height: 200%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}

.flu-model-fir-right {
  width: 236px;
  height: 160px;
}
.flu-model-fir-rig-btn {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flu-model-fir-rig-btn-font {
  width: calc(100% - 40px);
  height: 30px;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
}
.flu-model-fir-rig-btn-cancel {
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.flu-model-fir-rig-prompt {
  width: 100%;
  margin: 20px 0;
  word-wrap: break-word;
}
.flu-model-second {
  margin-top: 20px;
}
.flu-model-sec-progress {
  width: 100%;
  height: 12px;
  margin: 4px 0;
  box-sizing: border-box;
  border-radius: 10px;
  border: 2px solid #eee;
  position: relative;
}
.flu-model-sec-progress-solid {
  background: #ff6801;
  width: 0%;
  height: 100%;
  border-radius: 10px;
  border: 2px solid #ff6801;
  position: absolute;
  top: -2px;
  left: -2px;
  transition: all 0.2s ease-in-out 0s;
}
.flu-model-sec-data {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flu-model-sec-data-progs {
}
.flu-model-third {
  width: 100%; /* min-height:20px; */
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/fileUpload/fileUpload.vue